
export class UserDocument {

}
